module.exports = __webpack_public_path__ + "static/media/sad-cry.5bfe88e3.svg";